import React from "react";
import { CgArrowRight } from "react-icons/cg";
import { useNavigate } from "react-router";
import { openInNewTab } from "../Helper/helper";

function IntroductionText() {
    const navigate = useNavigate();
    return (
        <div className="mt-2 text-lg">
            👋 Hi, I'm Jack, currently studying software engineering in Bristol.
            I have experience with many technologies from web to games and
            virtual reality. I have worked professionally on games in Unity and
            looking to land a new role in tech!
            <div
                onClick={() =>
                    openInNewTab("https://www.linkedin.com/in/jackking1/")
                }
                className="flex items-center gap-1 opacity-60 text-sm mt-4 transition-all hover:cursor-pointer hover:opacity-100 font-sourcecodepro"
            >
                View Profile &rarr;
            </div>
        </div>
    );
}

export default IntroductionText;
